import he from 'he';

// Decodes entities the way a browser does when it reads an attribute value.
export const decodeHtmlAttribute = (value: string): string =>
  he.decode(value, { isAttributeValue: true });
